import type { FetchJobDescriptionDetailFragment } from '../../graphql';
import { salaryRangeTextWithType } from '../../utils';
import styles from './job-description-table.component.module.scss';
import { JobDescriptionTableElement } from './job-description-table-element.component';

type Props = {
  jobDescription: FetchJobDescriptionDetailFragment;
};

export const JobDescriptionTable = ({ jobDescription }: Props) => (
  <table className={styles.table}>
    <tbody>
      <JobDescriptionTableElement
        tdText={
          jobDescription.employmentPatternNote ??
          jobDescription.jobDescriptionEmploymentPattern?.name ??
          ''
        }
        thText="雇用形態"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.trialPeriod ?? ''}
        thText="試用期間"
      />
      <JobDescriptionTableElement
        tdText={
          salaryRangeTextWithType(
            jobDescription.basicSalaryMin,
            jobDescription.basicSalaryMax,
            jobDescription.basicSalaryType
          ) ||
          (jobDescription.salary ?? '')
        }
        thText="給与"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.salaryRemark ?? ''}
        thText="給与備考"
      />
      <JobDescriptionTableElement
        tdText={jobDescription.bonus ?? ''}
        thText="賞与"
      />
      <JobDescriptionTableElement
        tdText={
          jobDescription.numericSalaryMin
            ? `${jobDescription.numericSalaryMin * 0.0001}`
            : ''
        }
        thText="年収下限（万円）"
      />
      <JobDescriptionTableElement
        tdText={
          jobDescription.numericSalaryMax
            ? `${jobDescription.numericSalaryMax * 0.0001}`
            : ''
        }
        thText="年収上限（万円）"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.salaryExamples ?? ''}
        thText="給与例"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.location ?? ''}
        thText="勤務地"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.workHours ?? ''}
        thText="勤務時間"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.breakTime ?? ''}
        thText="休憩時間"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.overtimeWork ?? ''}
        thText="時間外労働"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.holidays ?? ''}
        thText="休日・有給休暇・特別休暇"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.welfare ?? ''}
        thText="福利厚生"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.otherBenefits ?? ''}
        thText="諸手当"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.insurance ?? ''}
        thText="加入保険"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.smokingPolicy ?? ''}
        thText="就業場所における受動喫煙を防止するための措置"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.careerUpPrograms ?? ''}
        thText="教育・スキルアップ・キャリアアップ"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.health ?? ''}
        thText="健康"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.screeningProcess ?? ''}
        thText="面接・選考プロセス"
      />
      <JobDescriptionTableElement
        addLink
        tdText={jobDescription.others ?? ''}
        thText="その他"
      />
    </tbody>
  </table>
);
